/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unusual_Absence_Detection_HelpInputs */



/**
* | output |
* | --- |
* | "During an unexpected absence of more than 1 hour, the room switches to pre-comfort temperature" |
*
* @param {Unusual_Absence_Detection_HelpInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const unusual_absence_detection_help = /** @type {((inputs?: Unusual_Absence_Detection_HelpInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unusual_Absence_Detection_HelpInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("During an unexpected absence of more than 1 hour, the room switches to pre-comfort temperature")
	return /** @type {LocalizedString} */ ("Lors d'une absence non prévue de plus de 1h, la pièce passe en température de pré-confort")
});